import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { GridColumn } from '@/models/GridColumn.model';
import { FieldType, SearchFieldModel } from '@/models/SearchField.model';
import { Grid } from '@/models/Grid.model';
import { Action, Getter, Mutation } from 'vuex-class';
import {
  APPROVE_ALL_FORMS,
  APPROVE_SELECTED_FORMS,
  FORM101_OFFICES_LIST,
  FORM101_UNITS_LIST,
  FORM101_UNITS_LIST_LOADING,
  FORM_101_FILTERS_LIST,
  FORM_101_STATUSES_LIST,
  FORMS_RESULT_DATA,
  FORMS_SEARCH,
  FORMS_SEARCH_ERRORS,
  FORMS_SEARCH_FILTERS,
  FORMS_SEARCH_OBJECT,
  GENERATE_DETAILED_FORMS_REPORT,
  GENERATE_EMPTY_FORM_101_AS_PDF,
  GENERATE_FORMS_SEARCH_REPORT,
  GET_FORM101_OFFICES_LIST,
  GET_FORM101_UNITS_LIST,
  GET_FORM_101_FILTERS_LIST,
  GET_FORM_101_STATUSES_LIST,
  GET_FORM_DATA,
  GET_ID_NUMBER_FIELDS,
  ID_NUMBER_FIELDS_DATA,
  MANAGER_GET_FORM_101_AS_PDF,
  MANAGER_GET_MANUAL_FORM_101_AS_PDF,
  MANAGER_LOADING,
  MANUAL_FORM,
  OPEN_APPROVE_FORMS_MODAL,
  OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL,
  OPEN_MANUAL_FORM_MODAL,
  OPEN_MANUAL_UPDATE_IPT_MODAL,
  OPEN_REMOVE_FORM_MODAL,
  RESET_FORMS_SEARCH_OBJECT,
  SEARCH_EMPLOYEES_CURRENT_FORM,
  SET_CAN_APPROVE,
  SET_CAN_REJECT,
  SET_FORM101_UNITS_LIST,
  SET_FORMS_RESULT_DATA,
  SET_FORMS_SEARCH_ERRORS,
  SET_FORMS_SEARCH_FILTERS,
  SET_FORMS_SEARCH_OBJECT,
  SET_MANAGER_LOADING,
  SET_MANAGER_MODE,
  SET_OPEN_APPROVE_FORMS_MODAL,
  SET_OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL,
  SET_OPEN_MANUAL_FORM_MODAL,
  SET_OPEN_MANUAL_UPDATE_IPT_MODAL,
  SET_OPEN_REMOVE_FORM_MODAL,
  SET_SEARCH_EMPLOYEES_CURRENT_FORM,
  SET_SELECTED_FORMS_TO_APPROVE,
  SET_STATUS_DESC,
  UPLOAD_MANUAL_FORM,
} from '@/types/managerForm.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import MockData from '@/globals/manager.mock.json';
import { CodeTable } from '@/models/base/CodeTable.interface';
import { FormActions } from '@/models/form/enum/FormActions';
import FormResetPasswordModal from '@/components/modals/FormResetPassword.modal.vue';
import { SET_FORM_READ_ONLY_MODE } from '@/types/form.types';
import RemoveFormModal from '@/components/modals/RemoveForm.modal.vue';
import { Form101SearchType } from '@/models/manager/enums/Form101SearchType';
import { RowAction } from '@/models/RowAction.model';
import { MenuAction } from '@/models/MenuAction.model';
import { Form101SearchModel } from '@/models/Form101Search.model';
import { eventsHub } from '@/main';
import ApproveFormsModal from '@/components/modals/ApproveForms.modal.vue';
import { InputFile } from '@/models/InputFile.model';
import { ManagerForm101Data } from '@/models/manager/ManagerForm101Data.model';
import { GetIdNumberFieldsResponseModel } from '@/models/manager/GetIdNumberFieldsResponse.model';
import { USER_DETAILS } from '@/types/authentication.types';
import { UserDetails } from '@/models/UserDetails.model';
import { ClickColumn } from '@/models/ClickColumn.model';
import { FormsSearchFilters } from '@/models/manager/forms-search-filters';
import { DOCUMENTS_ERRORS } from '@/types/documents.types';
import ManualUpdateIptModal from '@/components/modals/ManualUpdateIpt.modal.vue';
import { Utils } from '@/globals/Utils';

const NEXT_TAX_YEAR_MONTH = 9;
const NUMBER_OF_YEARS_TO_REDUCE = 7;

@Component({
  components: {
    FormResetPasswordModal,
    ManualUpdateIptModal,
    RemoveFormModal,
    ApproveFormsModal,
  },
})
export default class SearchEmployeesComponent extends Vue {

  @Action(FORMS_SEARCH, StoreNamespace.MANAGER) public formsSearch;
  @Action(GET_ID_NUMBER_FIELDS, StoreNamespace.MANAGER) public getIdNumberFields;
  @Action(GET_FORM101_OFFICES_LIST, StoreNamespace.MANAGER) public getForm101OfficesList;
  @Action(GET_FORM_101_FILTERS_LIST, StoreNamespace.MANAGER) public getForm101FiltersList;
  @Action(GET_FORM101_UNITS_LIST, StoreNamespace.MANAGER) public getForm101UnitsList;
  @Action(GET_FORM_101_STATUSES_LIST, StoreNamespace.MANAGER) public getForm101StatusesList;
  @Action(GET_FORM_DATA, StoreNamespace.MANAGER) public getFormData;
  @Action(MANAGER_GET_FORM_101_AS_PDF, StoreNamespace.MANAGER) public managerGetForm101AsPdf;
  @Action(MANAGER_GET_MANUAL_FORM_101_AS_PDF, StoreNamespace.MANAGER) public managerGetManualForm101AsPdf;
  @Action(GENERATE_EMPTY_FORM_101_AS_PDF, StoreNamespace.MANAGER) public generateEmptyForm101AsPdf;
  @Action(GENERATE_FORMS_SEARCH_REPORT, StoreNamespace.MANAGER) public generateFormsSearchReport;
  @Action(GENERATE_DETAILED_FORMS_REPORT, StoreNamespace.MANAGER) public generateDetailedFormsReport;
  @Action(APPROVE_SELECTED_FORMS, StoreNamespace.MANAGER) public approveSelectedForms;
  @Action(APPROVE_ALL_FORMS, StoreNamespace.MANAGER) public approveAllForms;
  @Action(UPLOAD_MANUAL_FORM, StoreNamespace.MANAGER) public uploadManualForm;

  @Mutation(SET_OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL, StoreNamespace.MANAGER)
  public setOpenManagerFormResetPasswordModal;
  @Mutation(SET_SEARCH_EMPLOYEES_CURRENT_FORM, StoreNamespace.MANAGER) public setSearchEmployeesCurrentForm;
  @Mutation(SET_FORMS_RESULT_DATA, StoreNamespace.MANAGER) public setFormsResultData;
  @Mutation(SET_MANAGER_MODE, StoreNamespace.MANAGER) public setManagerMode;
  @Mutation(SET_FORM_READ_ONLY_MODE, StoreNamespace.FORM) public setFormReadOnlyMode;
  @Mutation(SET_OPEN_REMOVE_FORM_MODAL, StoreNamespace.MANAGER) public setOpenRemoveFormModal;
  @Mutation(SET_OPEN_APPROVE_FORMS_MODAL, StoreNamespace.MANAGER) public setOpenApproveFormsModal;
  @Mutation(SET_OPEN_MANUAL_FORM_MODAL, StoreNamespace.MANAGER) public setOpenManualFormModal;
  @Mutation(SET_SELECTED_FORMS_TO_APPROVE, StoreNamespace.MANAGER) public setSelectedFormsToApprove;
  @Mutation(SET_FORMS_SEARCH_ERRORS, StoreNamespace.MANAGER) public setFormsSearchErrors;
  @Mutation(SET_CAN_APPROVE, StoreNamespace.MANAGER) public setCanApprove;
  @Mutation(SET_CAN_REJECT, StoreNamespace.MANAGER) public setCanReject;
  @Mutation(SET_STATUS_DESC, StoreNamespace.MANAGER) public setStatusDesc;
  @Mutation(SET_FORMS_SEARCH_OBJECT, StoreNamespace.MANAGER) public setFormsSearchObject;
  @Mutation(RESET_FORMS_SEARCH_OBJECT, StoreNamespace.MANAGER) public resetFormsSearchObject;
  @Mutation(SET_FORM101_UNITS_LIST, StoreNamespace.MANAGER) public setForm101UnitsList;
  @Mutation(SET_MANAGER_LOADING, StoreNamespace.MANAGER) public setManagerLoading;
  @Mutation(SET_FORMS_SEARCH_FILTERS, StoreNamespace.MANAGER) public setFormsSearchFilters;
  @Mutation(SET_OPEN_MANUAL_UPDATE_IPT_MODAL, StoreNamespace.MANAGER)
  public setOpenManualUpdateIptModal;

  @Getter(FORMS_RESULT_DATA, StoreNamespace.MANAGER) public formsResultData!: Grid;
  @Getter(ID_NUMBER_FIELDS_DATA, StoreNamespace.MANAGER) public idNumberFieldsData!: GetIdNumberFieldsResponseModel;
  @Getter(FORMS_SEARCH_ERRORS, StoreNamespace.MANAGER) public formsSearchErrors!: string[];
  @Getter(FORMS_SEARCH_OBJECT, StoreNamespace.MANAGER) public formsSearchObject!: Form101SearchModel;
  @Getter(FORM101_OFFICES_LIST, StoreNamespace.MANAGER) public form101OfficesList!: any[];
  @Getter(FORM101_UNITS_LIST, StoreNamespace.MANAGER) public form101UnitsList!: any[];
  @Getter(FORM101_UNITS_LIST_LOADING, StoreNamespace.MANAGER) public form101UnitsListLoading!: boolean;
  @Getter(FORM_101_FILTERS_LIST, StoreNamespace.MANAGER) public form101FiltersList!: any[];
  @Getter(FORM_101_STATUSES_LIST, StoreNamespace.MANAGER) public form101StatusesList!: CodeTable[];
  @Getter(SEARCH_EMPLOYEES_CURRENT_FORM, StoreNamespace.MANAGER) public searchEmployeesCurrentForm!: ManagerForm101Data;
  @Getter(OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL, StoreNamespace.MANAGER)
  public openManagerFormResetPasswordModal!: boolean;
  @Getter(OPEN_REMOVE_FORM_MODAL, StoreNamespace.MANAGER) public openRemoveFormModal!: boolean;
  @Getter(OPEN_APPROVE_FORMS_MODAL, StoreNamespace.MANAGER) public openApproveFormsModal!: boolean;
  @Getter(MANAGER_LOADING, StoreNamespace.MANAGER) public managerLoading!: boolean;
  @Getter(MANUAL_FORM, StoreNamespace.MANAGER) public manualForms!: Document[];
  @Getter(OPEN_MANUAL_FORM_MODAL, StoreNamespace.MANAGER) public openManualFormModal!: boolean;
  @Getter(FORMS_SEARCH_FILTERS, StoreNamespace.MANAGER) public formsSearchFilters!: FormsSearchFilters[];
  @Getter(USER_DETAILS, StoreNamespace.AUTHENTICATION) public userDetails!: UserDetails;
  @Getter(DOCUMENTS_ERRORS, StoreNamespace.DOCUMENT) public documentsErrors!: string[];
  @Getter(OPEN_MANUAL_UPDATE_IPT_MODAL, StoreNamespace.MANAGER) public openManualUpdateIptModal!: boolean;

  @Prop(String) public triggerSearch!: string;
  @Prop(String) public statusCode!: string;

  private searchFields: SearchFieldModel[] = [];
  private columns: GridColumn[] = [];
  private officeNum: number = 0;
  private managerMock = MockData.manager;
  private formTypes = [];
  private taxYears: Array<CodeTable<number>> = [];
  private rowActions: RowAction[] = [];
  private dataTableMenuActions: MenuAction[] = [];
  private showTooltip: boolean = false;
  private showFilters: boolean = false;
  private showSearch: boolean = false;
  private hideUnits: boolean = false;
  private FieldType = FieldType;
  private searched = false;
  private formsSearchFiltersCheckboxes = [];
  private formsSearchFiltersArr: FormsSearchFilters[] = [];
  private searchFilters: string = '';

  public created() {
    if (this.triggerSearch) {
      this.setFormsSearchObject({ ...this.formsSearchObject, ['statusCode']: +this.statusCode });
      // this.$emit('fetchSearch', this.formsSearchObject);
    }
  }

  public mounted() {
    this.setManagerLoading(false);
    this.taxYears = this.getTaxYears();
    this.formTypes = this.managerMock.formTypes;
    this.getForm101FiltersList();
    this.setFormsSearchErrors([]);
    this.getIdNumberFields();
    this.getForm101OfficesList();
    this.getForm101StatusesList();
    // this.setFormsSearchObject({ ...this.formsSearchObject, ['taxYear']: new Date().getFullYear() });
    this.setFormsSearchObject({ ...this.formsSearchObject, ['searchType']: 2 });
    // this.resetFormsSearchObject();
    this.initRowActions();
    this.initDataTableMenuActions();
    this.$on('menuActionClicked', this.menuActionClicked);
    // this.initSearchObject();
    // if (this.formsSearchObject.taxYear) {
    //   this.formsSearch(this.formsSearchObject);
    // }
    // this.showSearch = true;
    if (this.triggerSearch) {
      setTimeout(() => {
        // this.setFormsSearchObject({ ...this.formsSearchObject, ['statusCode']: +this.statusCode });
        this.$emit('fetchSearch', this.formsSearchObject);
      }, 100);
    }
    window.onpopstate = (event) => {
      console.log('location: ' + document.location + ', state: ' + JSON.stringify(event.state));
      this.$emit('fetchSearch', this.formsSearchObject);
    };
  }

  private initColumns() {
    if (this.idNumberFieldsData.idNumberField1) {
      const field1 = this.idNumberFieldsData.idNumberField1.split('.');
      this.columns.push({
        property: field1[0],
        innerProperty: field1[1],
        header: this.idNumberFieldsData.idNumberTitle1,
      } as GridColumn);
    }
    if (this.idNumberFieldsData.idNumberField2) {
      this.columns.push({
        property: this.idNumberFieldsData.idNumberField2,
        header: this.idNumberFieldsData.idNumberTitle2,
      } as GridColumn);
    }
    if (this.idNumberFieldsData.idNumberField3) {
      this.columns.push({
        property: this.idNumberFieldsData.idNumberField3,
        header: this.idNumberFieldsData.idNumberTitle3,
      } as GridColumn);
    }
    this.columns.push({
      property: 'fullName',
      header: 'employees_list.fullName',
    } as GridColumn);
    this.columns.push({
      property: 'orgUnitName',
      subProperty: 'officeName',
      header: 'employees_list.orgUnitNameAndOffice',
      hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'formStatusDesc',
      subProperty: 'statusDate',
      subPropertyDirection: 'ltr',
      header: 'forms.status',
      hideSorting: true,
      classProperty: 'status',
    } as GridColumn);
    this.columns.push({
      property: 'searchType',
      header: 'employees_list.searchType',
      hideSorting: true,
      filterName: 'filterSearchType',
    } as GridColumn);
    this.columns.push({
      property: 'taxYearAndRevision',
      header: 'employees_list.taxYearAndPositionNum',
      hideSorting: true,
    } as GridColumn);
    this.columns.push({
      clickEvent: 'VIEW',
      faIcon: 'eye',
      faIconType: 'fal',
      header: 'employees_list.view',
      hideSorting: true,
      checkActions: true,
    } as ClickColumn);
    this.columns.push({
      clickEvent: 'DOWNLOAD_PDF',
      faIcon: 'file-pdf',
      faIconType: 'fal',
      header: 'employees_list.download',
      hideSorting: true,
      checkActions: true,
    } as ClickColumn);
    this.columns.push({
      rowMenuActionsProperty: 'actions',
      faIcon: 'cog',
      header: 'employees_list.actions',
      hideSorting: true,
    } as ClickColumn);
  }

  private initRowActions() {
    // this.rowActions.push({
    //   name: 'EXPORT_EVENTS', faIcon: ['fal', 'calendar-star'], event: 'EXPORT_EVENTS',
    // } as RowAction);
    this.rowActions.push({ name: 'EXPORT_EXCEL', faIcon: ['fal', 'file-excel'], event: 'EXPORT_EXCEL' } as RowAction);
  }

  private initDataTableMenuActions() {
    // this.dataTableMenuActions.push({
    //   name: 'EXPORT_EVENTS', faIconType: 'fal', faIconName: 'calendar-star', event: 'EXPORT_EVENTS',
    // } as MenuAction);
    this.dataTableMenuActions.push({
      name: 'FORM_SEARCH_EXPORT_EXCEL', faIconType: 'fal', faIconName: 'file-excel', event: 'EXPORT_EXCEL',
    } as MenuAction);
    this.dataTableMenuActions.push({
      name: 'DETAILED_REPORT_EXPORT', faIconType: 'fa', faIconName: 'file-excel', event: 'DETAILED_REPORT_EXPORT',
    } as MenuAction);
    if (!this.userDetails.userRoles.includes('MANAGER_VIEW_ONLY')) {
      this.dataTableMenuActions.push({
        name: 'APPROVE_SELECTED', faIconType: 'fal', faIconName: 'check', event: 'APPROVE_SELECTED',
      } as MenuAction);
      this.dataTableMenuActions.push({
        name: 'APPROVE_ALL', faIconType: 'fal', faIconName: 'check-double', event: 'APPROVE_ALL',
      } as MenuAction);
    }

  }

  private updateFormsSearchObject(newVal: any, property: string, clear?: boolean) {
    if (property === 'officeNum' && (newVal || clear)) {
      this.hideUnits = true;
      this.setForm101UnitsList([]);
      this.updateFormsSearchObject(null, 'orgUnitFrom');
      this.updateFormsSearchObject(null, 'orgUnitTo');
      this.getForm101UnitsList(newVal);
      setTimeout(() => this.hideUnits = false, 0);
    }
    if (property === 'taxYear' && this.formsSearchObject.taxYear &&
      this.userDetails.allowTaxYearList.indexOf(this.formsSearchObject.taxYear) > -1) {
      this.setFormsSearchObject({ ...this.formsSearchObject, ['filters']: null });
      this.setFormsSearchFilters([]);
    }
    this.setFormsSearchObject({ ...this.formsSearchObject, [property]: newVal });
  }

  private updateFormsFilters(newVal: boolean, result: FormsSearchFilters, property: string) {
    // this.formsSearchFiltersArr = [...this.formsSearchFilters];
    if (newVal) {
      if (this.formsSearchFiltersArr.findIndex(x => x.code === result.code) === -1) {
        this.formsSearchFiltersArr.push(result);
      }
    } else {
      const index = this.formsSearchFiltersArr.findIndex(x => x.code === result.code);
      this.formsSearchFiltersArr.splice(index, 1);
    }
    // this.setFormsSearchFilters(this.formsSearchFiltersArr);
    // this.setFormsSearchObject({ ...this.formsSearchObject, ['filters']: result.code });
  }

  private initFiltersObj(result: FormsSearchFilters) {
    return !!(this.formsSearchFiltersArr.filter(x => x.code === result.code).length);
  }

  private removeFormsFilters(index: number) {
    const formsSearchFiltersArr = [...this.formsSearchFilters];
    formsSearchFiltersArr.splice(index, 1);
    this.setFormsSearchFilters(formsSearchFiltersArr);
    // this.setFormsSearchObject({ ...this.formsSearchObject, ['filters']: formsSearchFiltersArr.map(x => x.code) });
  }

  private closeFiltersModal() {
    this.searchFilters = '';
    this.showTooltip = false;
  }

  private approveFiltersModal() {
    this.searchFilters = '';
    this.setFormsSearchFilters([]);
    this.setFormsSearchFilters(this.formsSearchFiltersArr);
    this.showTooltip = false;
  }

  private onSearch(searchObject: any) {
    this.setManagerLoading(true);
    // this.searched = true;
    this.setFormsSearchErrors([]);
    const formFiltersCodes = this.formsSearchFilters && this.formsSearchFilters.length ?
      this.formsSearchFilters.map(x => x.code) : null;
    this.setFormsSearchObject({ ...this.formsSearchObject, ['filters']: formFiltersCodes });
    this.updateFormsSearchObject(searchObject.pageNumber, 'pageNumber');
    this.updateFormsSearchObject(searchObject.pageSize, 'pageSize');
    this.updateFormsSearchObject(searchObject.sortColumn, 'sortColumn');
    this.updateFormsSearchObject(searchObject.sortDirection, 'sortDirection');
    this.formsSearch();
  }

  private onClear(searchObject) {
    this.searched = true;
    this.setFormsSearchErrors([]);
    this.showSearch = false;
    this.setFormsResultData({} as Grid);
    searchObject.searchType = 2;
    searchObject.taxYear = new Date().getFullYear();
    this.formsSearchFiltersArr = [];
    this.updateFormsSearchObject(2, 'searchType');
    this.setFormsSearchObject(searchObject);
    this.setFormsSearchFilters([]);
    this.setForm101UnitsList([]);
    setTimeout(() => {
      this.showSearch = true;
      this.searched = false;
    }, 0);
  }

  private onTooltipClicked() {
    this.formsSearchFiltersArr = [...this.formsSearchFilters];
    this.showTooltip = true;
  }

  private onTdClicked(result: any, row: any) {
    switch (row.clickEvent) {
      case 'VIEW':
        this.setManagerLoading(true);
        this.setFormReadOnlyMode(true);
        this.setManagerMode(true);
        this.setCanApprove(result.canApprove);
        this.setCanReject(result.canReject);
        this.setStatusDesc(result.formStatusDesc);
        result.employeeId.formId = result.formId;

        this.getFormData({
          formId: result.formId,
          officeNum: result.employeeId.officeNum,
          idNum: result.employeeId.idNum,
          positionNum: result.employeeId.positionNum,
          routeToWizard: true,
        });
        break;
      case FormActions.DOWNLOAD_PDF:
        result.employeeId.docId = result.docId;
        if (result.searchType === Form101SearchType.MANUAL) {
          this.managerGetManualForm101AsPdf(result.employeeId);
        } else if (result.searchType === Form101SearchType.ELECTRONIC) {
          this.managerGetForm101AsPdf(result.employeeId);
        }
        break;
    }
  }

  private dynamicActionClicked(action: string, result: any) {
    switch (action) {
      case FormActions.VIEW:
        this.setManagerLoading(true);
        this.setFormReadOnlyMode(true);
        this.setManagerMode(true);
        this.setCanApprove(result.canApprove);
        this.setCanReject(result.canReject);
        this.setStatusDesc(result.formStatusDesc);
        result.employeeId.formId = result.formId;

        this.getFormData({
          formId: result.formId,
          officeNum: result.employeeId.officeNum,
          idNum: result.employeeId.idNum,
          positionNum: result.employeeId.positionNum,
          routeToWizard: true,
        });
        break;
      case FormActions.DOWNLOAD_PDF:
        result.employeeId.docId = result.docId;
        if (result.searchType === Form101SearchType.MANUAL) {
          this.managerGetManualForm101AsPdf(result.employeeId);
        } else if (result.searchType === Form101SearchType.ELECTRONIC) {
          this.managerGetForm101AsPdf(result.employeeId);
        }
        break;
      case FormActions.MANUAL_UPLOAD:
        this.setSearchEmployeesCurrentForm(result);
        this.openManualFileDialog();
        break;
      case FormActions.RESET_PASSWORD:
        this.setSearchEmployeesCurrentForm(result.employeeId);
        this.setOpenManagerFormResetPasswordModal(true);
        break;
      case FormActions.PRINT_BLANK:
        this.generateEmptyForm101AsPdf({
          officeNum: result.employeeId.officeNum,
          idNum: result.employeeId.idNum,
          positionNum: result.employeeId.positionNum,
          taxYear: this.formsSearchObject.taxYear,
        });
        break;
      case FormActions.MANUAL_REMOVE:
        result.employeeId.dateFrom = result.dateFrom;
        result.employeeId.dateTo = result.dateTo;
        result.employeeId.fullName = result.fullName;
        result.employeeId.searchType = result.searchType;
        result.employeeId.taxYear = result.taxYearAndRevision;
        this.setSearchEmployeesCurrentForm(result.employeeId);
        this.setOpenRemoveFormModal(true);
        break;
      case FormActions.REMOVE:
        result.employeeId.searchType = result.searchType;
        result.employeeId.formId = result.formId;
        result.employeeId.fullName = result.fullName;
        this.setSearchEmployeesCurrentForm(result.employeeId);
        this.setOpenRemoveFormModal(true);
        break;
      case FormActions.EXPORT_EVENTS:
        break;
      case FormActions.MANUAL_UPDATE_IPT:
        result.employeeId.formId = result.formId;
        this.setSearchEmployeesCurrentForm(result.employeeId);
        this.setOpenManualUpdateIptModal(true);
        break;
    }
  }

  private menuActionClicked(action: RowAction, selectedRows: any[]) {
    switch (action.name) {
      case FormActions.EXPORT_EVENTS:
        break;
      case FormActions.EXPORT_EXCEL:
      case FormActions.FORM_SEARCH_EXPORT_EXCEL:
        this.generateFormsSearchReport(this.formsSearchObject);
        break;
      case FormActions.APPROVE_ALL:
        this.setOpenApproveFormsModal(true);
        break;
      case FormActions.APPROVE_SELECTED:
        if (!selectedRows.length) {
          this.$notify({
            group: 'frd',
            type: 'error',
            text: '' + eventsHub.$t('form101.wizard.noSelectedRows'),
          });
          return;
        }
        for (const item of selectedRows) {
          if (!item.canApprove) {
            this.$notify({
              group: 'frd',
              type: 'error',
              text: '' + eventsHub.$t('form101.wizard.cannotApproveForm'),
            });
            return;
          }
        }
        this.setSelectedFormsToApprove(selectedRows);
        this.setOpenApproveFormsModal(true);
        break;
      case FormActions.DETAILED_REPORT_EXPORT:
        this.generateDetailedFormsReport(this.formsSearchObject);

    }
  }

  private getTaxYears(): Array<CodeTable<number>> {
    const currentYear = new Date().getFullYear();
    const arrTaxYears: Array<CodeTable<number>> = [];
    if (new Date().getMonth() >= NEXT_TAX_YEAR_MONTH) {
      arrTaxYears.push({
        code: currentYear + 1,
        description: '' + (currentYear + 1),
      });
    }
    for (let i = 0; i < currentYear - (currentYear - NUMBER_OF_YEARS_TO_REDUCE); i++) {
      arrTaxYears.push({
        code: currentYear - i,
        description: '' + (currentYear - i),
      });
    }
    return arrTaxYears;
  }


  private closeManualFileDialog() {
    this.setOpenManualFormModal(false);
  }

  private openManualFileDialog() {
    this.setOpenManualFormModal(true);
  }

  private onUploadClicked(file: InputFile, docType: number) {
    this.uploadManualForm({
      requestBody: {
        file,
        officeNum: this.searchEmployeesCurrentForm.employeeId.officeNum,
        idNum: this.searchEmployeesCurrentForm.employeeId.idNum,
        positionNum: this.searchEmployeesCurrentForm.employeeId.positionNum,
        taxYear: this.formsSearchObject.taxYear,
      },
    });
  }

  @Watch('idNumberFieldsData')
  private onIdNumberFieldsDataChanged() {
    this.initColumns();
  }

  private beforeDestroy() {
    // this.setForm101UnitsList([]);
    this.updateFormsSearchObject(undefined, 'sortColumn');
    this.updateFormsSearchObject(undefined, 'sortDirection');
  }

  private destroyed() {
    // if (!this.searched) {
    //   this.setFormsSearchObject({});
    // }
    this.setOpenManagerFormResetPasswordModal(false);
    this.setOpenRemoveFormModal(false);
    this.setOpenApproveFormsModal(false);
    this.setOpenManualFormModal(false);
  }

  get form101FiltersFilteredList(): FormsSearchFilters[] {
    const filtersList = [...this.form101FiltersList];
    return [...this.form101FiltersList].filter(item => !this.searchFilters
      || item.name.indexOf(this.searchFilters) !== -1
      || item.description.indexOf(this.searchFilters) !== -1);
  }

  private updateDate(date: Date, property: any) {
    this.updateFormsSearchObject(date ? Utils.dateToString(date) : date, property);
  }

}

